<template>
	<div class="eia-input"
		:class="classes">
		<input
			:type="type"
			:placeholder="placeholder"
			:value="value"
			@input="onInput"
			@keyup="onKeyUp"
			@blur="$emit( 'blur' )">

		<eia-icon
			v-if="isSearch"
			class="eia-input__search-icon"
			name="search"
			variation="default">
		</eia-icon>
	</div>
</template>

<script>
export default {
	name: 'eia-input',
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
		value: {
			type: [ String, Number ],
			default: '',
		},
		error: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		classes() {
			const classes = {
				[ `eia-input--${this.type}` ]: !!this.type,
				'eia-input--error': this.error,
			};

			return classes;
		},

		isSearch() {
			return this.type === 'search';
		},
	},

	methods: {

		onInput( $event ) {
			this.$emit( 'input', $event.target.value );
		},

		onKeyUp( $event ) {

			if( $event.keyCode === 13 ){
				this.$emit( 'enter' );
			}

		},

	},
};
</script>

<style lang="scss">
.eia-input {
	position: relative;
	display: inline-flex;
	align-items: center;

	input {
		display: inline-block;
		width: 100%;
		font-family: $font-family;
		font-size: $text-subheading-small;
		line-height: $text-subheading;
		color: $color-main;
		border: 2px solid $color-grey-medium;
		border-radius: $radius-default;
		padding: 16px 28px;

		&::-webkit-input-placeholder {
			color: $color-grey-dark;
			line-height: $text-subheading;
			font-size: $text-subheading-small;
		}

		&::placeholder,
		&::-moz-text-control-preview {
			color: $color-grey-dark;
			line-height: $text-subheading;
			font-size: $text-subheading-small;
		}

		&:active,
		&:focus {
			border-color: $color-main;
			outline: none;
		}
	}

	&--search {
		input {
			padding-right: 52px;
		}

		.eia-input__search-icon {
			position: absolute;
			display: flex;
			align-items: center;
			justify-content: center;
			right: 8px;
			padding: 16px;
			border-radius: $radius-full;
			background-color: $color-success;
			pointer-events: none;
		}
	}

	&--error {
		input {
			border-color: $color-danger;
		}
	}
}
</style>
